import React, { SyntheticEvent, useEffect } from 'react';
import { CloseOutlined } from '@mui/icons-material';
import {
  Box, Chip, FormControl, InputLabel,
  MenuItem, OutlinedInput, Select,
  SelectChangeEvent, TextField,
} from '@mui/material';
import { useAppSelector } from '../../../hooks/useAppSelector';
import { IQualification } from '../../../models/service/service';
import { cancellationPolicy, errorNames } from '../../../utils/constants';
import { cats } from '../../../utils/data';
import { convertedArrayReverse, openQualification } from '../../../utils/methods';
import { ErrorText } from '../../errorText/ErrorText';
import { borderInput } from '../../formAddress/formAddress.styles';
import {
  chipsItem, chipSize, chipsWrapper,
  errorBlock,
  formControl,
  selectErrorWrapper, selectWrapper,
} from './desciptionForm.styles';
import { IProps } from './types';

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: '200px',
    },
  },
};

export const DescriptionForm = (props: IProps): JSX.Element => {
  const requiredQualification = useAppSelector((state) => state.organizerReducer.requiredQualification);
  const { register, errors, required, categories,
    setCategories, qualifications, setQualifications,
    edit, setValue, opportunities, submitted } = props;

  useEffect(() => {
    if (edit && opportunities) {
      const getQualification = openQualification(opportunities.qualifications).flat().map(String);
      setValue('details', opportunities.details);
      setValue('cancellationPolicy', opportunities.cancellationPolicy);
      setValue('categories', opportunities.categories);
      setValue('qualifications', getQualification);
      setCategories(convertedArrayReverse(opportunities.categories));
      setQualifications(getQualification);
    }
  }, [opportunities]);

  const handleChangeSelectQualifications = (e: SelectChangeEvent<typeof qualifications>) => {
    const { target: { value } } = e;
    setQualifications(
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const handleChangeSelect = (e: SelectChangeEvent<typeof categories>) => {
    const { target: { value } } = e;
    if (categories.length >= 3) {
      console.log('error');
    }
    else {
      const resValue = typeof value === 'string' ? value.split(',') : value;
      setCategories(resValue);
      setValue('categories', resValue);
    }
  };

  const handleDeleteCategories = (selected: string): void => {
    setCategories(categories.filter((item) => item !== selected));
    setValue('categories', categories.filter((item) => item !== selected));
  };

  return (
    <Box sx={selectWrapper}>
      <FormControl fullWidth>
        <InputLabel
          sx={
            !!((categories.length === 0 && !!errors?.categories)
            || (submitted && categories.length > 3))
              ? selectErrorWrapper
              : null
          }
          id="Categories*"
        >Categories*
        </InputLabel>
        <Select
          labelId="demo-multiple-chip-label"
          id="demo-multiple-chip"
          multiple
          value={categories}
          onChange={handleChangeSelect}
          input={
            <OutlinedInput
              id="select-multiple-chip"
              label="Categories"
              sx={borderInput}
            />
          }
          MenuProps={MenuProps}
          error={!!(submitted && (!categories.length || categories.length > 3))}
        >
          {cats.map((cat) => (
            <MenuItem
              key={cat}
              value={cat}
            >
              {cat}
            </MenuItem>
          ))}
        </Select>
        {
          (submitted && categories.length > 3) ? <ErrorText text={errorNames.categoriesLength} />
            : categories.length ? <Box sx={chipsWrapper}>
              {categories.map((selected) => (
                <Box sx={chipsItem}>
                  <Chip
                    key={selected}
                    sx={chipSize}
                    label={selected}
                    deleteIcon={<CloseOutlined fontSize="small" />}
                    onDelete={() => handleDeleteCategories(selected)}
                  />
                </Box>
              ))}
            </Box>
              : errors?.categories ? <ErrorText text={errorNames.categoriesRequired} /> : null
        }
      </FormControl>
      <FormControl sx={formControl}>
        <TextField
          id="outlined-multiline-static"
          label="Description*"
          fullWidth
          multiline
          rows={4}
          {...register('details', {
            required,
            maxLength: 3000,
          })}
          error={!!errors?.details}
          sx={borderInput}
          variant="outlined"
        />
        <Box sx={errorBlock}>
          {errors?.details?.type === 'required' && <ErrorText text={errorNames.descriptionRequired} />}
          {errors?.details?.type === 'maxLength' && <ErrorText text={errorNames.descriptionLength} />}
        </Box>
      </FormControl>
      <FormControl fullWidth>
        <InputLabel id="Required qualifications">Required qualifications</InputLabel>
        <Select
          labelId="demo-multiple-chip-label"
          id="demo-multiple-chip"
          multiple
          {...register('qualifications')}
          value={qualifications}
          onChange={handleChangeSelectQualifications}
          input={
            <OutlinedInput
              id="select-multiple-chip"
              label="Required qualifications"
              sx={borderInput}
            />
          }
          MenuProps={MenuProps}
        >
          {requiredQualification.map((item: IQualification) => (
            <MenuItem
              key={item.id}
              value={item.content}
            >
              {item.content}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl sx={formControl}>
        <TextField
          id="outlined-multiline-static"
          label="Cancellation policy*"
          fullWidth
          multiline
          rows={4}
          defaultValue={cancellationPolicy}
          {...register('cancellationPolicy', {
            required,
            maxLength: 3000,
          })}
          error={!!errors?.cancellationPolicy}
          sx={borderInput}
          variant="outlined"
        />
        <Box sx={errorBlock}>
          {errors?.cancellationPolicy?.type === 'required' && <ErrorText text={errorNames.cancellationPolicyRequired} />}
          {errors?.cancellationPolicy?.type === 'maxLength' && <ErrorText text={errorNames.cancellationPolicyLength} />}
        </Box>
      </FormControl>

    </Box>
  );
};
